import { CSSProperties, SVGProps } from 'react'

interface TiktokPlatformIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

/**
 * TikTok platform icon component
 */
const TiktokPlatformIcon = ({
    className,
    style,
    color = 'white',
    size = 52,
    onClick,
}: TiktokPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        height={size * (40 / 92)}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24.9045 15.575C24.3854 15.2377 23.9587 14.7762 23.6631 14.2323C23.3675 13.6884 23.2124 13.0793 23.2118 12.4602H20.5403L20.5358 23.1672C20.5189 23.6072 20.373 24.0324 20.1162 24.3901C19.8595 24.7477 19.5032 25.022 19.0917 25.1786C18.6802 25.3353 18.2318 25.3675 17.8021 25.2712C17.3725 25.1748 16.9807 24.9543 16.6755 24.637C16.3703 24.3196 16.1652 23.9195 16.0857 23.4865C16.0062 23.0534 16.0558 22.6066 16.2283 22.2015C16.4009 21.7965 16.6888 21.4511 17.0562 21.2085C17.4236 20.9658 17.8542 20.8366 18.2945 20.8368C18.5193 20.8376 18.7428 20.8726 18.9571 20.9406V18.2133C18.7375 18.1823 18.5162 18.1662 18.2945 18.165C15.583 18.165 13.3772 20.3712 13.3772 23.0827C13.3772 23.7284 13.5044 24.3679 13.7515 24.9645C13.9986 25.5611 14.3608 26.1031 14.8174 26.5598C15.274 27.0164 15.8161 27.3786 16.4127 27.6257C17.0093 27.8728 17.6487 28 18.2945 28C18.9402 28 19.5797 27.8728 20.1763 27.6257C20.7728 27.3786 21.3149 27.0164 21.7715 26.5598C22.2282 26.1031 22.5904 25.5611 22.8375 24.9645C23.0846 24.3679 23.2118 23.7284 23.2118 23.0827V17.6533C24.2947 18.432 25.5951 18.8502 26.9288 18.8487V16.1769C26.2099 16.1774 25.5064 15.9683 24.9045 15.575Z"
            fill={color}
        />
        <path
            d="M29.4803 16.1901H37.9049L37.1329 18.5989H34.9444V27.5106H32.2223V18.5989L29.4822 18.6042L29.4803 16.1901Z"
            fill={color}
        />
        <path
            d="M51.7052 16.1901H60.3245L59.5509 18.5989H57.1738V27.5106H54.4465V18.5989L51.7063 18.6042L51.7052 16.1901Z"
            fill={color}
        />
        <path
            d="M38.4184 19.7909H41.1197L41.1167 27.5106H38.4346L38.4184 19.7909Z"
            fill={color}
        />
        <path
            d="M42.189 16.1584H44.8873V21.4288L47.561 18.8049H50.7815L47.3995 22.0877L51.1875 27.5095H48.2149L45.6868 23.7494L44.8873 24.5271V27.5079H42.189V16.1584Z"
            fill={color}
        />
        <path
            d="M69.6244 16.1584H72.3226V21.4288L74.9964 18.8049H78.2169L74.8349 22.0877L78.6229 27.5095H75.6503L73.1222 23.7494L72.3226 24.5271V27.5079H69.6244V16.1584Z"
            fill={color}
        />
        <path
            d="M39.7681 18.9087C40.5189 18.9087 41.1276 18.3 41.1276 17.5492C41.1276 16.7983 40.5189 16.1897 39.7681 16.1897C39.0173 16.1897 38.4086 16.7983 38.4086 17.5492C38.4086 18.3 39.0173 18.9087 39.7681 18.9087Z"
            fill={color}
        />
        <path
            d="M63.9068 18.2684C62.9927 18.2681 62.0991 18.5388 61.339 19.0464C60.5789 19.554 59.9863 20.2756 59.6363 21.12C59.2864 21.9644 59.1946 22.8936 59.3728 23.7901C59.5509 24.6866 59.9909 25.5101 60.6371 26.1566C61.2833 26.803 62.1067 27.2433 63.0032 27.4217C63.8996 27.6001 64.8289 27.5087 65.6733 27.159C66.5178 26.8093 67.2396 26.217 67.7475 25.457C68.2553 24.697 68.5264 23.8035 68.5264 22.8895C68.5264 21.6642 68.0397 20.489 67.1734 19.6224C66.3071 18.7558 65.1321 18.2688 63.9068 18.2684ZM63.9068 25.1357C63.4624 25.1358 63.028 25.0041 62.6585 24.7572C62.289 24.5104 62.001 24.1595 61.8309 23.749C61.6608 23.3385 61.6163 22.8867 61.7029 22.4509C61.7896 22.0151 62.0036 21.6147 62.3178 21.3005C62.632 20.9863 63.0324 20.7723 63.4682 20.6857C63.904 20.599 64.3558 20.6435 64.7663 20.8136C65.1768 20.9837 65.5277 21.2717 65.7745 21.6412C66.0214 22.0107 66.1531 22.4451 66.153 22.8895C66.1529 23.4852 65.9162 24.0565 65.495 24.4777C65.0738 24.8989 64.5025 25.1356 63.9068 25.1357Z"
            fill={color}
        />
    </svg>
)

export default TiktokPlatformIcon
